import type { Translation } from '../types.ts';
import type en from '../en/themes.ts';

export default {
    versions: {
        title: 'Themaversies',
        intro: 'Rol een tag uit vanuit de git-repo van {code}. De worker downloadt, valideert en compileert de tarball.',
        tag: 'Tag',
        deploy: 'Uitrollen',
        clear: 'Wissen',
        removeCount: '{n} verwijderen',
        empty: 'Nog niets uitgerold.',
        selectAll: 'Alle verwijderbare versies selecteren',
        version: 'Versie',
        branch: 'branch',
        remote: 'extern',
        confirmRemove: 'Verwijderen?',
        activate: 'Activeren',
        skip: 'Overslaan: deze tag verbergen zonder uit te rollen',
        removeVersion: 'Versie verwijderen',
        bulkFailed: 'Sommige versies konden niet worden verwijderd: {failures}',
    },
    status: {
        queued: 'in wachtrij',
        success: 'gelukt',
        failed: 'mislukt',
        available: 'beschikbaar',
    },
} satisfies Translation<typeof en>;
